import 'client-only';

import { proxyFetch } from '@ps/functions/utils/proxyFetch';

/** The clip-report reasons the picker offers (`ReportReasonEnumItem`). */
export type ClipReportReason = 'spam' | 'inappropriate' | 'aggressive';

export interface SubmitClipReportInput {
  /** The clip id being reported. */
  clipId: string;
  /** The creator who owns the clip (`video.author.id`). */
  targetId: string;
  reason: ClipReportReason;
  /** Optional content pointer (the clip's video URL). */
  content?: string;
}

/**
 * Submit an abuse report for a clip. Posts to the server-side `/api/report`
 * route handler via {@link proxyFetch} (which attaches the caller's Firebase ID
 * token) — the actual `reports` Firestore write happens server-side, so the
 * visitor bundle never loads `firebase/firestore`. Throws on a non-2xx response
 * (the caller shows the error); resolves on success.
 */
export async function submitClipReport(
  input: SubmitClipReportInput,
): Promise<void> {
  await proxyFetch<{ ok: true }>('/api/report', {
    method: 'POST',
    body: {
      reason: input.reason,
      contentType: 'VideoClip',
      documentId: input.clipId,
      targetId: input.targetId,
      content: input.content,
    },
  });
}
